import { windowWidth } from "src/styles/global";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  height: 100%;
`;

const Content = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  
  .mainInfoRow{
    display: flex;
    align-items: center;
  }
`;

interface IconContainerProps {
  color: string;
}

const IconContainer = styled.div<IconContainerProps>`
  margin-right: 15px;
  height: 100%;
  display: flex;
  align-items: center;

  svg {
    fill: ${({ color }) => color};
    margin-top: 10px;
  }

  .barStatusColor {
    background-color: ${({ color }) => color};
  }
`;

const BarStatus = styled.div`
  height: 100%;
  width: 10px;
  border-radius: 10px;
`;

const InfoContainer = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: #666666;
  
  width: 100%;

  .titleHeader {
    font-size: 15px;
    font-weight: 700;
    color: #000;
  }

  .titleContent {
    font-weight: 700;
    color: #000;
  }

  .contentColor {
    color: ${({ color }) => color};
    font-weight: 600;
  }

  .creditLimitValue {
    font-size: 29px;
  }

  .pendencyContent {
    font-weight: 700;
    color: #ff0000;
  }

  .checkboxContent {
    display: flex;
    align-items: center;
    padding-top: 3px;
  }
`;

const ConcretingResume = styled.div`
  display: flex;
  justify-content: space-between;
  width: 95%;
  
  margin-top: 1rem;
    
  .concretingResumeColumn {    
    display: flex;
    flex-direction: column;
    gap: 4px;
    
    .resumeIcon {
      margin-right: 2px;
      
      svg {
        width: 12px;
      }
    }
    
    
    .resumeItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
            
      font-size: 12px;
      white-space: nowrap;
      
      gap: 8px;
      
      div {
        gap: 2px;
        display: flex;
        align-items: center;
      }
    }
  }
  
  @media (max-width: ${windowWidth.tablet}) {
    gap: 10px;
    
    .concretingResumeColumn {
      gap: 2px;
      
      .resumeIcon {
        svg {
          width: 10px;
          margin-right: 0;
        }
      }
      
      .resumeItem {
        font-size: 10px;
        
      }
      
    }
  }
`;

const ActionContainer = styled.div``;

export {
  Container,
  Content,
  IconContainer,
  InfoContainer,
  ActionContainer,
  BarStatus,
  ConcretingResume
};
